:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-1{flex-shrink:1;}
:root ._grow-1{flex-grow:1;}
:root ._bg-divider{background-color:var(--divider);}
:root ._maxH-1px{max-height:1px;}
:root ._height-1px{height:1px;}
:root ._mt-t-space-med104641{margin-top:var(--t-space-medium);}
:root ._mb-t-space-med104641{margin-bottom:var(--t-space-medium);}